// extracted by mini-css-extract-plugin
export default {"tooltip":"AU-z","arrow":"BU-z"};